import React, { memo, useEffect, useState } from 'react';
import ApiService from '../../services/ApiService';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import moment from 'moment';

function ChatPackages({ forcePaypal }) {
    const { userData } = useSelector(state => state.auth);
    const [packages, setPackages] = useState([]);
    const [selectPackages, setSelectPackages] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const navigate = useNavigate();

    const getAllChatPackages = async () => {
        try {
            const response = await new ApiService().GET(`/get-all-chat-membership-plan`);
            if (response.data.status === '1') {
                setPackages(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching chat packages:", error);
        }
    };

    const chkSelectChatPlan = async () => {
        try {
            const response = await new ApiService().GET(`/check-user-chat-plan-status/${userData.id}`);
            if (response.data.status === '1') {
                setSelectPackages(response.data);
            }
        } catch (error) {
            console.error("Error checking chat plan status:", error);
        }
    };

    const chooseAmount = (amount, chat_plan_id) => {
        if (selectPackages === null) {
            navigate(forcePaypal ? "/paypal-payment" : "/payment", {
                state: {
                    payment_type: "recharge",
                    amount,
                    chat_plan_id
                }
            });
        }
    };

    const getRemainingTimeText = (unixTimestamp) => {
        const expirationDate = moment.unix(unixTimestamp);
        const currentDate = moment();

        if (expirationDate.isBefore(currentDate)) {
            return "Expired";
        } else {
            const diffDays = expirationDate.diff(currentDate, 'days');
            if (diffDays > 0) {
                return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} remaining`;
            }
            const diffHours = expirationDate.diff(currentDate, 'hours');
            return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} remaining`;
        }
    };

    useEffect(() => {
        getAllChatPackages();
        if (userData?.id) {
            chkSelectChatPlan();
        }
    }, [userData?.id]);

    return (
        <div className="container py-5">
            <div className="text-center mb-5">
                <h2 className="mb-2" style={{ color: '#222222', fontSize: '2.4rem', fontFamily: 'inherit' }}>
                    Chat Package Plans
                </h2>
                <p className="text-muted" style={{ fontSize: '1.05rem', letterSpacing: '0.3px' }}>plans that work for everyone</p>
            </div>

            <div className="row justify-content-center g-4">
                {packages.map((item, index) => {
                    const isActive = selectPackages?.chat_plan_id == item.id;
                    const isHovered = hoveredIndex === index;

                    // Calculate original price before discount for visual strikethrough
                    let originalAmount = null;
                    if (packages[0]?.amount) {
                        const baseWeeklyPrice = Number(packages[0].amount);
                        if (item.validity === "monthly") {
                            originalAmount = (baseWeeklyPrice * 4).toFixed(2);
                        } else if (item.validity === "quarterly") {
                            originalAmount = (baseWeeklyPrice * 12).toFixed(2);
                        } else if (item.validity === "yearly") {
                            originalAmount = (baseWeeklyPrice * 52).toFixed(2);
                        }
                    }

                    return (
                        <div
                            key={"chat_package_" + index}
                            className="col-12 col-md-6 col-lg-4"
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div
                                onClick={() => chooseAmount(item.amount, item.id)}
                                style={{
                                    cursor: selectPackages === null ? 'pointer' : 'default',
                                    background: '#ffffff',
                                    border: isActive
                                        ? '2px solid #8ABB45'
                                        : (isHovered ? '2px solid #8ABB45' : '2px solid #eaeaea'),
                                    borderRadius: '20px',
                                    padding: '30px 24px',
                                    height: '100%',
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    boxShadow: isActive
                                        ? '0 12px 40px rgba(138, 187, 69, 0.15)'
                                        : (isHovered ? '0 12px 30px rgba(0, 0, 0, 0.08)' : '0 8px 20px rgba(0, 0, 0, 0.04)'),
                                    transform: isHovered && selectPackages === null ? 'translateY(-5px)' : 'none',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                            >
                                {/* Top Badges Section */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* Discount Percentage */}
                                    {item.validity === "monthly" && (
                                        <span className="badge px-3 py-2 rounded-pill" style={{ background: '#ff2d55', color: '#fff', fontSize: '0.8rem', fontWeight: 'bold' }}>30% OFF</span>
                                    )}
                                    {item.validity === "quarterly" && (
                                        <span className="badge px-3 py-2 rounded-pill" style={{ background: '#ff2d55', color: '#fff', fontSize: '0.8rem', fontWeight: 'bold' }}>60% OFF</span>
                                    )}
                                    {item.validity === "yearly" && (
                                        <span className="badge px-3 py-2 rounded-pill" style={{ background: '#ff2d55', color: '#fff', fontSize: '0.8rem', fontWeight: 'bold' }}>80% OFF</span>
                                    )}
                                    {!item.validity || item.validity === "weekly" ? <span></span> : null}

                                    {/* Active Plan Tag */}
                                    {isActive && (
                                        <span className="badge px-3 py-2 rounded-pill" style={{ background: '#8ABB45', color: '#fff', fontSize: '0.8rem', fontWeight: 'bold' }}>
                                            Active Plan
                                        </span>
                                    )}
                                </div>

                                {/* Plan Title */}
                                <h3 className="h4 fw-bold mb-3 text-dark text-uppercase" style={{ letterSpacing: '0.5px', color: '#333' }}>
                                    {item.plan_name}
                                </h3>

                                {/* Price Display */}
                                <div className="mb-4">
                                    {originalAmount && (
                                        <div className="text-muted text-decoration-line-through mb-1" style={{ fontSize: '0.85rem' }}>
                                            ${originalAmount}
                                        </div>
                                    )}
                                    <div className="d-flex align-items-baseline" style={{ color: '#222', flexWrap: 'nowrap' }}>
                                        <span style={{ fontSize: '2.2rem', fontWeight: '800', color: '#222', lineHeight: '1.1', letterSpacing: '-1px' }}>
                                            ${Number(item.amount).toFixed(2)}
                                        </span>
                                        <span className="text-muted ms-2" style={{ textTransform: 'capitalize', fontSize: '0.95rem', whiteSpace: 'nowrap', fontWeight: '500' }}>
                                            / {item.validity}
                                        </span>
                                    </div>
                                </div>

                                {/* Feature List */}
                                <ul className="list-unstyled mb-4 flex-grow-1">
                                    <li className="d-flex align-items-center mb-3" style={{ fontSize: '0.95rem', color: '#555' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8ABB45" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px', flexShrink: 0 }}>
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                        Start chatting with friends instantly
                                    </li>
                                    <li className="d-flex align-items-center mb-3" style={{ fontSize: '0.95rem', color: '#555' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8ABB45" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px', flexShrink: 0 }}>
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                        Unlimited incoming chat messages
                                    </li>
                                </ul>

                                {/* Action / Expiration Status */}
                                {selectPackages === null ? (
                                    <button
                                        type="button"
                                        className="btn w-100 py-2.5 fw-bold rounded-pill mt-auto"
                                        style={{
                                            background: isHovered ? 'linear-gradient(135deg, #a3d958, #8ABB45)' : 'linear-gradient(135deg, #8ABB45, #729d33)',
                                            color: '#fff',
                                            border: 'none',
                                            transition: 'all 0.3s ease',
                                            boxShadow: isHovered ? '0 4px 15px rgba(138, 187, 69, 0.3)' : 'none'
                                        }}
                                        onClick={() => chooseAmount(item.amount, item.id)}
                                    >
                                        Choose Plan
                                    </button>
                                ) : (
                                    isActive && (
                                        <div className="mt-auto pt-3 border-top" style={{ borderColor: '#eaeaea' }}>
                                            <div className="d-flex justify-content-between text-muted mb-1" style={{ fontSize: '0.8rem' }}>
                                                <span>Started:</span>
                                                <span style={{ color: '#444' }}>{moment.unix(selectPackages.start_time).format("MM/DD/YYYY")}</span>
                                            </div>
                                            <div className="d-flex justify-content-between text-muted mb-1" style={{ fontSize: '0.8rem' }}>
                                                <span>Expires:</span>
                                                <span style={{ color: '#444' }}>{moment.unix(selectPackages.expire_time).format("MM/DD/YYYY")}</span>
                                            </div>
                                            <div className="d-flex justify-content-between text-muted" style={{ fontSize: '0.8rem' }}>
                                                <span>Status:</span>
                                                <span className="fw-semibold" style={{ color: '#8ABB45' }}>
                                                    {getRemainingTimeText(selectPackages.expire_time)}
                                                </span>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default memo(ChatPackages);